<template>
  <div>
    <!-------------Start toast / snackbar --------------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------------end toast / snackbar --------------------------->
    <!--------- heading ------------------->
    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Study Groups & Events</h1>
      </v-col>
      <!--------------------------- add  --------------------------------------->
      <v-col md="6" sm="6">
        <v-card flat class="d-flex justify-end mt-2">
          <!-- <v-btn color="primary">Add new</v-btn> -->
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            @click="addEventDialog = true"
          >
            Add new
          </v-btn>
          <v-dialog
            v-model="addEventDialog"
            max-width="600"
            persistent
            scrollable
          >
            <v-card v-if="addEventDialog">
              <EventAndGroupComponent
                :addEventDialog="addEventDialog"
                @close="close"
              ></EventAndGroupComponent>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <!--------- search , filter and buttons ------------------->
    <v-row class="mt-6">
      <v-col cols="12" md="4" sm="6">
        <v-card flat>
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            v-model="searchQuery"
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="7">
        <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
          @click="filterDialog = true"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div class="d-flex justify-space-between align-center">
              <v-icon>mdi-tune</v-icon>
              <span class="text_style mx-1" style="letter-spacing: 1px"
                >Filters</span
              >
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card>
        <!------------------------fliter diloag------------------------------------------>
        <v-dialog v-model="filterDialog" max-width="430">
          <v-card class="py-5">
            <v-card-title
              class="mb-5 d-flex justify-space-between align-center"
            >
              <div class="text-h5"><b> Filters</b></div>
              <div>
                <v-btn text depressed class="pa-0" @click="cleanFilter()">
                  <span
                    class="text_style primary--text"
                    style="letter-spacing: 0px"
                    >Clean filters</span
                  >
                </v-btn>
                <v-icon class="ml-3" @click="filterDialog = false"
                  >mdi-close</v-icon
                >
              </div>
            </v-card-title>

            <v-card-text>
              <div class="mt-4 mb-3"><b> In-Person or Online</b></div>
              <v-select
                outlined
                attach
                v-model="filterTypeModality"
                :items="filterTypeModalityList"
                item-text="name"
                item-value="id"
                dense
                hide-details
                multiple
                persistent-hint
                :menu-props="{ maxHeight: '400' }"
              ></v-select>
              <div class="mt-4 mb-3"><b> Frequency</b></div>
              <v-select
                outlined
                attach
                v-model="filterFrequency"
                :items="filterFrequencyList"
                dense
                :menu-props="{ maxHeight: '400' }"
                hide-details
                multiple
                persistent-hint
              ></v-select>
              <div class="mt-4"><b> Date</b></div>
              <v-menu
                ref="datarangemenu"
                attach
                v-model="datarangemenu"
                :close-on-content-click="false"
                :return-value.sync="Renewaldates"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="Renewaldates"
                    append-icon="mdi-calendar"
                    readonly
                    class="my-5"
                    dense
                    hide-details
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dates" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="datarangemenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.datarangemenu.save(Renewaldates)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <div class="mt-4 mb-3"><b> Modality</b></div>
              <v-select
              attach
                outlined
                v-model="filterModality"
                :items="filterModalityList"
                dense
                :menu-props="{ maxHeight: '300' }"
                hide-details
                multiple
                persistent-hint
              ></v-select>
              <div class="mt-4 mb-3"><b> Type</b></div>
              <v-select
                outlined
                attach
                v-model="filterTypeEvent"
                :items="filterTypeEventList"
                :menu-props="{ maxHeight: '400' }"
                dense
                hide-details
                multiple
                persistent-hint
              ></v-select>
              <div class="mt-4 mb-3"><b> Language</b></div>
              <v-select
                outlined
                v-model="filterLanguage"
                :items="LanguageList"
                attach
                :menu-props="{ maxHeight: '200' }"
                dense
                hide-details
                multiple
                persistent-hint
              ></v-select>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#646464"
                outlined
                depressed
                class="px-5"
                text
                @click="filterDialog = false"
              >
                <span class="text_style"> Cancel </span>
              </v-btn>
              <v-btn
                color="primary"
                class="px-8 ml-2"
                @click="
                  filterDialog = false;
                  sendFilters();
                "
                depressed
              >
                <span class="text_style white--text"> Save Filters </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <!--------- data table ------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :items-per-page="displayedItemsPerPage"
        :page.sync="page"
        :loading="tableLoader"
        @page-count="pageCount = $event"
        hide-default-footer
        loading-text="Loading... Please wait"
        :items="GetEventAndGroup"
      >
        <template v-slot:[`item.index`]="{ index }">
          <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
        </template>
        <template v-slot:[`item.LocationAddress`]="{ item }">
          <span class="table_style_two">
            {{
              item.EventLocationType == 1 ? item.LocationAddress : item.UrlLink
            }}
          </span>
        </template>
        <template v-slot:[`item.EventDate`]="{ item }">
          <span class="table_style_two">
            {{
              item.OccurrenceType == "One-Time Event"
                ? formatDate(item.EventDate)
                : ""
            }}
          </span>
        </template>
        <!-- <template v-slot:[`item.Mordality`]="{ item }">
          <span class="table_style_two"> {{ item.Modality }} </span>
        </template>
        <template v-slot:[`item.EventType`]="{ item }">
          <span class="table_style_two"> {{ item.Type }} </span>
        </template> -->

        <!-- <template v-slot:[`item.location`]="{ item }">
          <span class="table_style_two"> {{ item.location }} </span>
        </template> -->

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="PreviewEvent(item)"
                >
                  <v-icon color="#646464">mdi-open-in-new</v-icon>
                  <span class="ml-4 text_style">Preview</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="OpenEditEventDialog(item)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="ConfirmDelete(item)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination
    ></v-card>
    <!----------Preview dialog------------------>
    <v-dialog v-model="Previewdialog" max-width="640">
      <v-card class="pa-6">
        <div class="d-flex justify-space-between mb-6">
          <div class="previewHeading"># {{ previewDetails.id }}</div>
          <v-icon class="mx-5" @click="Previewdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <div class="mb-5">
            <div class="heading-4">General information</div>
          </div>
          <v-row class="" v-if="previewDetails.eventLocationType == 1">
            <v-col cols="4">
              <div class="index_span_2_style">Location name</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">{{ previewDetails.locationName }}</div>
            </v-col>
          </v-row>
          <v-row class="" v-if="previewDetails.eventLocationType == 1">
            <v-col cols="4">
              <div class="index_span_2_style">Location Address</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">
                {{ previewDetails.locationAddress }}
              </div>
            </v-col>
          </v-row>
          <v-row class="" v-if="previewDetails.eventLocationType == 2">
            <v-col cols="4">
              <div class="index_span_2_style">URL link</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">
                {{ previewDetails.urlLink }}
              </div>
            </v-col>
          </v-row>
          <v-row class="">
            <!-- {{ previewDetails.EventDateType }} -->
            <v-col cols="4">
              <div class="index_span_2_style">Modality</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">{{ previewDetails.mordality }}</div>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col cols="4">
              <div class="index_span_2_style">Type</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">{{ previewDetails.eventType }}</div>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col cols="4">
              <div class="index_span_2_style">Language</div>
            </v-col>
            <v-col cols="6">
              <div class="index_h4">{{ previewDetails.language }}</div>
            </v-col>
          </v-row>
        </div>
        <div class="mb-5 mt-8">
          <div class="heading-4">Dates information</div>
        </div>
        <v-row class="">
          <v-col cols="4">
            <div class="index_span_2_style">Time Zone</div>
          </v-col>
          <v-col cols="6">
            <div class="index_h4">{{ previewDetails.timezone }}</div>
          </v-col>
        </v-row>
        <!-- <v-card v-if="previewDetails.recurringDetails != null" class="my-5 pa-3 d-flex justify-center" color="#ECF1F2" flat>
          <div class="index_h4">
            Meets the last Friday of every month at 10:00am
          </div>
        </v-card> -->

        <v-card
          class="my-5 pa-3 d-flex justify-center"
          color="#ECF1F2"
          flat
          v-if="setDataStudyGroup.OccurrenceType == 'Recurring Event'"
        >
          <div
            class="index_h4"
            v-if="
              setDataStudyGroup.RecurringDetails.RecurringEventType == 'Weekly'
            "
          >
            Meet every
            {{ setDataStudyGroup.RecurringDetails.RepeatWeekly }} weeks on
            {{ setDataStudyGroup.RecurringDetails.WeeklyDays }}
          </div>
          <div
            v-if="
              setDataStudyGroup.RecurringDetails.RecurringEventType == 'Monthly'
            "
          >
            <div
              v-if="setDataStudyGroup.RecurringDetails.MonthlyRepeatType == 1"
            >
              Meet first
              {{ setDataStudyGroup.RecurringDetails.RepeatDay }} days of every
              {{ setDataStudyGroup.RecurringDetails.RepeatMonth }} months
            </div>
            <div
              v-if="setDataStudyGroup.RecurringDetails.MonthlyRepeatType == 2"
            >
              Meet on the
              {{ setDataStudyGroup.RecurringDetails.RepeatWeek }} week of
              {{ setDataStudyGroup.RecurringDetails.RepeatWeekDay }} of every
              months
            </div>
          </div>
          <!-- </div> -->
        </v-card>

        <div class="">
          <div><b> Host contact details </b></div>

          <div class="py-1 index_span_2_style">
            {{ previewDetails.hostName }}
          </div>
          <div class="py-1 index_span_2_style">
            {{ previewDetails.hostEmail }}
          </div>
          <div class="py-1 index_span_2_style">
            {{ previewDetails.hostPhoneNumber }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!----------Edit dialog------------------>
    <v-dialog v-model="EditEventDialog" persistent max-width="600">
      <v-card v-if="EditEventDialog">
        <EditEventAndGroupComponent
          :EditEventDialog="EditEventDialog"
          :setDataStudyGroup="EditEventItem"
          @close="close"
        ></EditEventAndGroupComponent>
      </v-card>
    </v-dialog>
    <!----------Delete dialog------------------>
    <v-dialog v-model="dialog" persistent max-width="390">
      <v-card class="pa-4">
        <div class="d-flex justify-space-between mb-4">
          <v-card-title class="text-h5"> Delete Event </v-card-title>
          <v-icon class="mx-5" @click="dialog = false">mdi-close</v-icon>
        </div>
        <v-card-text class="index_span_2_style mb-4"
          >Are you sure you want to delete [id_event] at
          [event-location]?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#646464"
            outlined
            depressed
            text
            @click="dialog = false"
          >
            <span class="text_style"> Don’t delete </span>
          </v-btn>
          <v-btn
            color="primary"
            class="px-5"
            depressed
            :disabled="btnloader"
            @click="DdialogClose()"
          >
            <span class="text_style" v-if="btnloader != true">
              Delete Event
            </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import EventAndGroupComponent from "../../components/EventAndGroup/AddEventAndGroup.component.vue";
import EditEventAndGroupComponent from "../../components/EventAndGroup/EditEventAndGroup.component.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    EventAndGroupComponent,
    EditEventAndGroupComponent,
  },
  data() {
    return {
      filtersArray: [],
      datarangemenu: false,
      // dates: ["2019-09-10", "2019-09-20"],
      dates: [],
      EditEventItem: [],
      filterLanguage: "",
      addEventDialog: false,
      filterTypeEvent: [],
      filterTypeEventList: [
        "Study Group",
        "Public Talk",
        "Expo",
        "Other Event",
      ],
      filterModality: [],
      filterModalityList: [
        "Access",
        "BodyTalk",
        "BodyTalk for Animals",
        "BreakThrough",
        "MindScape",
        "FreeFall",
        "PaRama",
      ],
      LanguageList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      filterFrequency: [],
      filterFrequencyList: ["Recurring Event", "One-Time Event"],
      searchQuery: "",
      searchTimer: null,
      filterDate: [],
      filterDateList: ["Recurring", "One time"],
      filterTypeModality: "",
      filterTypeModalityList: [
        { name: "Online", id: 2 },
        { name: "In-Person", id: 1 },
      ],
      filterDialog: false,
      Previewdialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      SuccessToast: false,
      ErrorToast: false,
      uploadfiledialog: false,
      createnewgroupdialog: false,
      EditEventDialog: false,
      btnloader: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      deleteId: 0,
      filterObj: {},
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Location", value: "LocationAddress" },
        { text: "Date", value: "EventDate" },
        { text: "Modality", value: "Modality" },
        { text: "Type", value: "Type" },
        { text: "", value: "actions", sortable: false },
      ],
      downloadDataTableOne: [],
      setDataStudyGroup: [],
      previewDetails: {
        locationName: "",
        locationAddress: "",
        mordality: "",
        eventType: "",
        timezone: "",
        eventLocationType: 0,
        urlLink: "",
        id: null,
        language: "",
        hostName: "",
        hostEmail: "",
        hostPhoneNumber: "",
        recurringDetails: [],
      },
    };
  },

  mounted() {
    this.fetchData();
  },
  methods: {
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    formatDate(dateString) {
    if(dateString){
      const date = new Date(dateString);
      return date.toLocaleDateString();
    }
    },
    sendFilters() {
      this.filtersArray = [];
      if (this.filterTypeEvent.length > 0) {
        this.filtersArray.push({
          Key: "Type",
          Value: this.filterTypeEvent.join(","),
        });
      }
      if (this.dates.length > 0) {
        let dates = [...this.dates];

        if (dates.length > 1) {
          dates.sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateA - dateB;
          });
        }

        this.filtersArray.push({
          Key: "Date",
          Value: dates.join(","),
        });
      }
      if (this.filterModality.length > 0) {
        this.filtersArray.push({
          Key: "modality",
          Value: this.filterModality.join(","),
        });
      }

      if (this.filterFrequency.length > 0) {
        this.filtersArray.push({
          Key: "OccurrenceType",
          Value: this.filterFrequency.join(","),
        });
      }
      if (this.filterLanguage.length > 0) {
        this.filtersArray.push({
          Key: "Language",
          Value: this.filterLanguage.join(","),
        });
      }
      if (this.filterTypeModality.length > 0) {
        this.filtersArray.push({
          Key: "eventlocationtype",
          Value: this.filterTypeModality.join(","),
        });
      }
      this.page = 1;
      this.fetchData(JSON.stringify(this.filtersArray));
    },
    OpenEditEventDialog(item) {
      this.EditEventDialog = true;
      this.EditEventItem = item;
    },
    ConfirmDelete(item) {
      this.deleteId = item.Id;
      this.dialog = true;
    },
    PreviewEvent(item) {
      this.setDataStudyGroup = item;
      this.previewDetails.locationName = item.LocationTitle;
      this.previewDetails.locationAddress = item.LocationAddress;
      this.previewDetails.mordality = item.Modality;
      this.previewDetails.eventType = item.Type;
      this.previewDetails.timezone = item.TimeZone;
      this.previewDetails.eventLocationType = item.EventLocationType;
      this.previewDetails.urlLink = item.UrlLink;
      this.previewDetails.id = item.Id;
      this.previewDetails.recurringDetails = item.RecurringDetails;
      this.previewDetails.language = item.Language;
      this.previewDetails.hostName = item.HostName;
      this.previewDetails.hostEmail = item.HostEmail;
      this.previewDetails.hostPhoneNumber = item.HostPhoneNumber;
      this.Previewdialog = true;
    },
    cleanFilter() {
      this.filterTypeEvent = [];
      this.filterModality = [];
      this.filterFrequency = [];
      this.filterTypeModality = [];
      this.filterLanguage = [];
      this.dates = [];
    },
    async DdialogClose() {
      this.btnloader = true;
      this.$store.dispatch("DeleteEventAndGroup", this.deleteId).then(() => {
        this.dialog = false;
        this.btnloader = false;
        this.EditEventDialog = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Event Deleted Successfully",
          showConfirmButton: false,
          timer: 2500,
        });
        this.fetchData();
      });
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.EditEventDialog = false;
        this.btnloader = false;
        this.uploadfiledialog = false;
        this.createnewgroupdialog = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.addEventDialog = false;
      this.EditEventDialog = false;
      this.SuccessToast = false;
      this.ErrorToast = false;
      this.fetchData();
    },
    async fetchData() {
      var obj = {
        page: this.page,
        pageSize: this.itemsPerPage,
        search: this.searchQuery,
        filters: JSON.stringify(this.filtersArray) ?? [],
      };
      this.tableLoader = true;
      await this.$store.dispatch("GetEventAndGroup", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
          if (res.page > this.pageCount) {
            this.page = 1;
          } else {
            this.page = res.page;
          }
        } else {
          this.pageCount = 1;
          this.page = 1;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["GetEventAndGroup"]),
    // Renewaldates() {
    //   return this.dates.join(" to ");
    // },
    Renewaldates() {
      return this.dates.join(" to ");
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetEventAndGroup.length
        : this.itemsPerPage;
    },
  },
  watch: {
    searchQuery() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.fetchData();
      }, 700);
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: rgba(34, 34, 34, 1);
}
.gray {
  color: #646464;
}
.previewHeading {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 700;
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
